import React from 'react'
import { LoadLiftingComponent, LoadLiftingProps } from './LoadLiftingComponent'

const LoadLifting: React.FC<LoadLiftingProps> = (props) => (
  <LoadLiftingComponent {...props} booleanPropertyName='loadLifting' amountPropertyName='loadLiftingValue' />
)
export default LoadLifting
